import React from "react"
import { VscCircleLargeFilled } from "react-icons/vsc"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, Modal, } from "components"
import classes from "./OrderStockValidationResultModal.module.scss"

const OrderStockValidationResultModal = props => {
  const {
    problematicItems,
    openOrderValidationResultModal,
    setOpenOrderValidationResultModal
  } = props

  const i18n = useTranslation()[1]

  const handleOk = () => {
    setOpenOrderValidationResultModal(false)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openOrderValidationResultModal}
      onHide={() => setOpenOrderValidationResultModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["list"]}>
          {problematicItems.map((problematicItem, index) =>
            <div
              key={index}
              className={classes["card"]}
            >
              <VscCircleLargeFilled
                name="checkbox-blank-circle"
                size={5}
                className={clsx(
                  classes["dot"],
                  isLtr && classes["dot-ltr"]
                )}
              />
              {
                problematicItem.type === "limitedFood" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    {problematicItem.foodName}{" "}
                    {!problematicItem.isSimple ? `(${problematicItem.optionName})` : ""}
                    <b className={classes["red"]}>
                      محدود
                    </b>
                    {" "}شده است لطفا سفارشتان را تا {" "}
                    <b>
                      حداکثر {problematicItem.availableQuantity}
                      {" "}{problematicItem.foodName}{" "}
                      {!problematicItem.isSimple ? `(${problematicItem.optionName})` : ""}
                    </b>
                    {" "}محدود کنید.
                  </div>
                </div>
              }
              {
                problematicItem.type === "deletedFood" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    {problematicItem.foodName}{" "}
                    {!problematicItem.isSimple ? `(${problematicItem.optionName})` : ""}
                    {" "}
                    <b className={classes["red"]}>
                      ناموجود شده است.
                    </b>
                  </div>
                </div>
              }

            </div>
          )}
        </div>

        <div className={classes["footer"]}>
          <Button
            color="success"
            onClick={handleOk}
          >
            تایید
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default OrderStockValidationResultModal